import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';
import { Loader2 } from 'lucide-react';

export default function AdminGuard({ children }) {
  const { isAuthed, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="w-8 h-8 animate-spin text-brand-magenta" />
      </div>
    );
  }

  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
}
